module.exports = __webpack_public_path__ + "img/step4.684ccd81.png";